import React from 'react';
import { parseURL } from '@common/utils';
import './index.less';

document.title = '路客云';

class App extends React.Component {
  render () {
    const url = window.location.href;
    const { params } = parseURL(url);
    const { isReview } = params;
    return (
      <div>
        <div className="contentWrapper">
          <p className="bold title">路客云隐私政策</p>
          <p className="date">版本发布时间：2021年9月14日</p>
          <p className="date">生效时间：2021年9月14日</p>
          <p>
            您的个人信息安全对我们来说至关重要。一直以来，路客云都致力于为每位用户提供更安全的互联网环境。我们将依据《中华人民共和国网络安全法》、《信息安全技术
            个人信息安全规范》（GB/T
            35273-2017）以及其他相关法律法规和技术规范收集和使用您的个人信息，以帮助我们向您提供更优质的路客云产品和/或服务。《路客云隐私保护指引》（以下简称“本指引”）透明地呈现我们收集和使用您个人信息的情况，以及您享有的对个人信息的控制权。我们承诺会对您的个人信息和其它数据进行严格保密，并严格按照本指引所阐述的内容处理您的个人信息。我们会根据您的同意和其它可处理您个人信息的法律依据收集、使用、存储、共享和转移您的个人信息。
          </p>
          <p>目录</p>
          <ul>
            <li>
              <a href="#num1">1. 引言；</a>
            </li>
            <li>
              <a href="#num2">2. 我们处理个人信息的法律依据；</a>
            </li>
            <li>
              <a href="#num3">3. 我们如何收集和使用您的个人信息；</a>
            </li>
            <li>
              <a href="#num4">4. 我们如何共享、转让、公开披露您的个人信息；</a>
            </li>
            <li>
              <a href="#num5">5. 我们如何保护您的个人信息；</a>
            </li>
            <li>
              <a href="#num6">6. 您管理个人信息的权利；</a>
            </li>
            <li>
              <a href="#num7">7. 我们发出的通知；</a>
            </li>
            <li>
              <a href="#num8">8. 对个人信息的存储；</a>
            </li>
            <li>
              <a href="#num9">9. 我们如何使用 Cookie 和其他追踪技术；</a>
            </li>
            <li>
              <a href="#num10">10. 我们如何处理未成年人的个人信息；</a>
            </li>
            <li>
              <a href="#num11">11. 如何更新本指引；</a>
            </li>
            <li>
              <a href="#num12">12. 如何联系我们；</a>
            </li>
            <li>
              <a href="#num13">13. 争议解决；</a>
            </li>
            <li>
              <a href="#num14">14. 名词解释。</a>
            </li>
          </ul>

          <div>
            <p className="bold subTitle">以下是《路客云隐私保护指引》的要点说明：</p>
            <p>1. 为帮助您注册并使用路客云产品或服务，我们可能收集与提供服务相关的个人信息，您有权拒绝或撤回授权；</p>
            <p>
              2.
              您可以访问、更正、删除您的个人信息，改变您授权同意的范围，注销您的帐号，我们为您提供了行使这些权利的途径。
            </p>
            <p>3. 我们采取了互联网业内标准的技术措施和数据安全措施来保护您的个人信息安全。</p>
            <p>4. 除非再次征得您的同意，我们不会将您的个人信息用于本指引未载明的其他目的。</p>
            <p>5. 当您对本指引有任何疑问，可以和我们进一步联系与咨询。</p>
            <p>6. 请确认您为 18 岁以上人士。</p>
            <p className="bold subTitle">
              为了更好保护您的个人信息，建议您完整阅读更新的《路客云隐私保护指引》。您也可以与路客云取得联系，获得路客云《隐私权政策》的历史版本。
            </p>
          </div>

          <div id="num1">
            <p className="bold subTitle">1. 引言</p>
            <p>
              本指引适用于路客云APP（统称为「路客云」或者「APP」）的广州民宿宝互联网科技有限公司（以下简称「我们」）。
            </p>
            <p className="subTitle">【特别提示】</p>
            {!isReview ? (
              <p className="subTitle">
                请您在使用我们的各项产品和/或服务前，仔细阅读并充分理解本指引。重点内容我们已采用粗体表示，希望您特别关注。一旦您使用或继续使用路客云产品/服务，即表示您同意我们按照本指引处理您的相关信息。如对本指引有任何疑问，您可以通过路客云官方网站（https://www.minsubao.net/）/
                App 上以及本指引中「如何联系我们」一节提供的联系方式/客服系统与我们联系。
              </p>
            ) : (
              <p className="subTitle">
                请您在使用我们的各项产品和/或服务前，仔细阅读并充分理解本指引。重点内容我们已采用粗体表示，希望您特别关注。一旦您使用或继续使用路客云产品/服务，即表示您同意我们按照本指引处理您的相关信息。
              </p>
            )}
            <p>
              为了便于您理解本指引中的相关概念，我们对专有名词标记了下划线并在本指引第 14
              节「名词解释」中给予详细介绍。本指引中相关名词的右上角用“*”标记的，代表涉及路客云收集的敏感信息，我们向您加以增强式提示。
            </p>
            <p>
              我们可能会不时对《路客云隐私保护指引》进行修订。当《路客云隐私保护指引》发生变更时，我们会在版本更新后以推送通知、弹窗等形式向您展示变更后的内容。请您注意，只有在您确认同意变更后，我们才会按照更新后的《路客云隐私保护指引》收集、使用、处理和存储您的个人信息。
            </p>
          </div>

          <div id="num2">
            <p className="bold subTitle">2. 路客云处理个人信息的法律依据</p>
            <p>
              如果您是中华人民共和国大陆地区的用户，我们将依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》（GB/T
              35273-2017）以及其他相关法律法规收集和使用您的个人信息，为您提供路客云产品和/或服务。 我们通常只会在征得您同意的情况下收集您的个人信息。 在某些情况下，我们可能还会基于法律义务或者履行合同之必需向您收集个人信息，或者可能需要个人信息来保护您的重要利益或其他人的利益。
            </p>
          </div>

          <div id="num3">
            <p className="bold subTitle">3. 我们如何收集和使用您的个人信息</p>
            <p>
              我们会遵循正当、合法、必要的原则，出于本指引所述的以下目的，收集和使用您在使用服务过程中主动提供或因使用路客云产品和/或服务而产生的个人信息。如果我们要将您的个人信息用于本指引未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。
            </p>
            <p>（一）您需要授权我们收集和使用个人信息的场景</p>
            <table styles="table" border="1">
              <tr>
                <th className="width80">业务场景</th>
                <th>收集目的</th>
                <th className="width100">收集的方式</th>
                <th>个人信息字段</th>
              </tr>
              <tr>
                <td className="width80">注册</td>
                <td>注册成为路客云用户，使用路客云提供的基础服务</td>
                <td className="width100">用户输入</td>
                <td className="bold color000 fz20">昵称，手机号码</td>
              </tr>
              <tr>
                <td className="width80">第三方账号登录</td>
                <td>
                  第三方账号和路客云账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息
                </td>
                <td className="width100">第三方获取用户共享的账号信息</td>
                <td className="bold color000 fz20">如头像、昵称、地区、性别等信息</td>
              </tr>
              <tr>
                <td className="width80">基础服务</td>
                <td>用户用户统计、优化路客云的功能体验</td>
                <td className="width100">APP收集</td>
                <td className="bold color000 fz20">
                  设备型号、操作系统、唯一设备标识符、MAC地址、登录IP地址、路客云软件版本号、接入网络的方式和类型、设备加速器、操作日志信息、SD卡信息、ANDROIDID、剪切板
                </td>
              </tr>
              <tr>
                <td className="width80">第三方网站</td>
                <td>
                  用户可以在我们的网站上找到链接到我们的合作伙伴、供应商、广告商、赞助商、许可方和其他第三方的网站和服务的广告或其他内容。我们不控制出现在这些网站上的内容或链接，也不对链接到我们网站或从我们网站链接过来的网站所采用的做法负责。此外，这些网站或服务，包括其内容和链接，可能会不断变化。这些网站和服务可能有自己的隐私政策和客户服务政策。在任何其他网站上浏览及互动，包括与本网站有连结的网站，均须遵守本网站的条款及政策
                </td>
                <td className="width100">用户授权的第三方获取用户共享的账号信息</td>
                <td className="bold color000 fz20">平台账号、昵称、房源信息、订单信息</td>
              </tr>
              <tr>
                <td className="width80">个人中心</td>
                <td>完善用户信息</td>
                <td className="width100">用户输入</td>
                <td className="bold color000 fz20">头像、邮箱、昵称</td>
              </tr>
              <tr>
                <td className="width80">身份认证</td>
                <td>使用路客云的高级版分销功能</td>
                <td className="width100">用户输入</td>
                <td className="bold color000 fz20">姓名、身份证号</td>
              </tr>
              <tr>
                <td className="width80">建议反馈</td>
                <td>方便解决用户问题</td>
                <td className="width100">APP收集</td>
                <td className="bold color000 fz20">姓名、手机号码、电子邮件及其他联系方式等个人信息</td>
              </tr>
              <tr>
                <td className="width80">消息推送</td>
                <td>用于向用户推送消息</td>
                <td className="width100">APP收集</td>
                <td className="bold color000 fz20">应用列表信息</td>
              </tr>
            </table>
            <p className="subTitle">3.1 征得授权同意的例外</p>
            <p>
              根据相关法律法规的规定， 在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：
            </p>
            <p>a. 与国家安全、国防安全直接相关的；</p>
            <p>b. 与公共安全、公共卫生、重大公共利益直接相关的；</p>
            <p>c. 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
            <p>d. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
            <p>e. 所收集的个人信息是您自行向社会公众公开的；</p>
            <p>f. 从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；</p>
            <p>g. 根据您的要求签订和履行合同所必需的；</p>
            <p>h. 用于维护路客云的产品和/或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
            <p>i. 法律法规规定的其他情形。</p>
            <p className="subTitle">
              3.2
              为您提供安全保障为了保障您的账号安全、交易安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您使用我们的产品/服务过程中，经您授权我们会获取您的设备信息，包括您使用的设备属性、连接和状态信息，例如设备型号、设备标识符（如
              IMEI/androidID/IDFA/OPENUDID/GUID/OAID/ICCID/UUID 信息等）等软硬件特征信息。
            </p>
            <p className="subTitle">
              3.3
              如果您对我们收集和使用您的个人信息的法律依据有任何疑问或需要提供进一步的信息，请通过「如何联系我们」一节提供的联系方式与我们联系。
            </p>
            <p>（二）您可以选择授权我们收集和使用个人信息的场景</p>
            <p>
              为向您提供更好的服务，您可以选择使用我们提供的拓展功能，我们会在符合法律规定并根据您具体授权的情况下收集并使用如下信息。这类信息将在您选择的具体功能和业务场景中进行收集，如果您不提供这些信息，不会影响您使用路客云的基本功能。
            </p>
            <p className="subTitle">3.4基于相机授权的拓展功能</p>
            <p className="subTitle">
              您可以选择开启系统的相机权限，通过使用拍照、录视频，扫码等功能授权路客云访问您的相机，以便于您通过拍摄照片或录制视频等方式发布内容，如果您需要录制并发布有声视频时，您还需开启麦克风权限。我们会收集您上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现扫码功能，或者无法通过拍摄图片、视频等方式进行点评或互动，但不会影响您享受路客云的基本功能。
            </p>
            <p className="subTitle">3.5基于相册授权的拓展功能</p>
            <p className="subTitle">
              您可以选择开启系统的相册权限，通过主动上传图片、视频等方式授权我们访问您的相册，以便于您通过上传照片或上传视频等方式发布内容。我们会收集您选择上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频等方式进行更换头像、消息图片发送功能等，但不会影响您享受路客云的基本功能。
            </p>
            <p className="subTitle">3.6基于麦克风授权的拓展功能</p>
            <p className="subTitle">
              您可以选择开启系统的麦克风权限，正常使用新手引导的视频播放功能。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现视频播放，但不会影响您享受路客云服务的基本功能。
            </p>
            <p>（三）设备权限</p>
            <p>
              为确保相关业务功能的正常实现，我们需要根据具体的使用场景调用对应的必
              要权限，并在调用前向您弹窗询问，具体的权限调用说明请见下表：
            </p>
            <p>1. Android 系统权限调用说明</p>
            <table styles="table" border="1">
              <tr>
                <th className="width100">设备权限</th>
                <th>使用目的</th>
                <th className="width100">是否询问</th>
                <th>是否可关闭</th>
              </tr>
              <tr>
                <td className="width100">悬浮窗</td>
                <td>快速预览推送消息</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">位置</td>
                <td>用于向用户推荐周边的民宿 预定功能等</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">拨打电话</td>
                <td>用于用户拨打电话，联系客户</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">电话状态</td>
                <td>获取设备识别码用于保障用 户的账号及交易安全</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">相机</td>
                <td>用于扫码、拍照、上传图片/视频</td>
                <td className="width100">用户主动扫码、拍照、上传图片/视频时询问</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">录音</td>
                <td>用于录制视频时获取声音</td>
                <td className="width100">用户发起语音功能时询问</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">存储</td>
                <td>用于存储和读取上传用户拍摄的照片和视频，以及实现应用内升级和页面数据缓存等</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">SD卡</td>
                <td>用于校验用户图片存储功能</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">获取日历</td>
                <td>用于获取用户日历信息</td>
                <td className="width100">否</td>
                <td>是</td>
              </tr>
            </table>
            <p>2. IOS 系统权限调用说明</p>
            <table styles="table" border="1">
              <tr>
                <th className="width100">设备权限</th>
                <th>使用目的</th>
                <th>是否询问</th>
                <th>是否可关闭</th>
              </tr>
              <tr>
                <td className="width100">照片</td>
                <td>用于扫码、拍照、上传图片 /视频</td>
                <td>用户主动扫码、拍 照、上传图片/视频 时询问</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">siri与搜索</td>
                <td>语音快速唤起APP</td>
                <td>否</td>
                <td>是</td>
              </tr>
              <tr>
                <td className="width100">通知</td>
                <td>及时通知用户</td>
                <td>否</td>
                <td>是</td>
              </tr>
            </table>
            <p>3. 路客云接入第三方SDK目录</p>
            <p className="subTitle">
              为保障路客云App相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的。不同版本的第三方SDK会有所不同，一般包括一键登录类、第三方账号登录类、推送通知消息类、第三方支付类、地图导航类、厂商推送类、分享类、统计类等。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保障数据安全。您可以通过以下链接查看第三方的数据使用和保护规则。
            </p>
            <table styles="table" border="1">
              <tr>
                <th className="width100">功能类型</th>
                <th>使用目的</th>
                <th>使用场景</th>
                <th className="width100">第三方名称</th>
                <th>涉及个人信息</th>
                <th className="width100">第三方官网链接</th>
              </tr>
              <tr>
                <td className="width100" rowspan="5">
                  推送通知消息
                </td>
                <td rowspan="5">
                  根据用户机型，为用户提供通知信息推送功能，从极光消息通知可跳转到APP，所以需要读取（设备APP列表、Android
                  ID、加速度传感器、Mac 地址）等信息，用于实现APP消息推送
                </td>
                <td rowspan="5">用户使用推送相关功能时使用</td>
                <td className="width100">极光;极光推送</td>
                <td>设备信息：</td>
                <td className="width100">https://docs.jiguang.cn//jpush/guideline/intro/</td>
              </tr>
              <tr>
                <td className="width100">华为</td>
                <td>设备信息：OAID、AndroidID、设备序列号、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</td>
                <td className="width100">https://developer.huawei.com/consumer/cn/service/hms/pushservice.html  </td>
              </tr>
              <tr>
                <td className="width100">OPPO PUSH 客户端SDK com.heytap.msp</td>
                <td>设备信息：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</td>
                <td className="width100">https://open.oppomobile.com/wiki/doc#id=10704</td>
              </tr>
              <tr>
                <td className="width100">小米</td>
                <td>设备信息：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址息</td>
                <td className="width100">https://dev.mi.com/console/appservice/push.html </td>
              </tr>
              <tr>
                <td className="width100">vivo PUSH-SDK com.vivo.push</td>
                <td>设备信息：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</td>
                <td className="width100">https://dev.vivo.com.cn/documentCenter/doc/366#w1-08185430</td>
              </tr>
              <tr>
                <td className="width100">第三方账号登录</td>
                <td>根据用户选择，为用户提供第三方账号登录功能</td>
                <td>用户使用第三方微信快捷登录时使用</td>
                <td className="width100">TBS腾讯浏览服务;腾讯浏览服务;腾讯X5浏览器;腾讯浏览器</td>
                <td>设备信息：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</td>
                <td className="width100">https://open.weixin.qq.com/</td>
              </tr>
              <tr>
                <td className="width100">埋点数据</td>
                <td>收集用户使用数据，进行分析</td>
                <td>记录用户使用app时候相关操作数据</td>
                <td className="width100">GrowingIo</td>
                <td>
                  设备信息：AndroidID、OAID、设备序列号、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址、行为事件数据（如点击、浏览、停留时长等）、设备分辨率、系统语言、运营商信息、设备MAC地址、广告标识符（如IMEI/IDFA/IDFV/MEID等，具体采集情况请以官方SDK说明为准）
                </td>
                <td className="width100">https://www.growingio.com/</td>
              </tr>
              <tr>
                <td className="width100">相机</td>
                <td>获取SD卡数据、用于存储图片信息</td>
                <td>用户使用图片存储功能时使用</td>
                <td className="width100">com.reactnativecommunity.cameraroll</td>
                <td>
                  设备信息：访问设备存储（SD卡）中的图片、视频及相关媒体文件，可能涉及访问媒体文件的元数据（如文件名、创建时间、尺寸等）、设备型号、操作系统版本、应用包名。
                </td>
                <td className="width100">https://reactnative.dev/</td>
              </tr>
              <tr>
                <td className="width100">阿里巴巴SDK</td>
                <td>获取SD卡数据、用户存储图片信息、上传图片信息</td>
                <td>用户使用图片上传与下载功能时使用</td>
                <td className="width100">com.alibaba.sdk</td>
                <td>
                  设备信息： 访问设备存储（SD卡）上的图片、视频及文档文件，设备型号、操作系统版本、设备序列号、应用版本号、包名、网络类型、IP地址，可能涉及上传文件的元数据信息。
                </td>
                <td className="width100">https://open.aliyun.com/</td>
              </tr>
              <tr>
                <td className="width100">阿里云号码认证服务</td>
                <td>获取用户当前手机SIM卡信息</td>
                <td>用户使用一键登录时使用</td>
                <td className="width100">com.mobile.auth</td>
                <td>
                  设备信息：手机SIM卡信息（包括SIM卡运营商、号码归属地）、设备IMEI、IMSI、AndroidID、OAID、设备型号、操作系统版本、应用包名、IP地址、网络类型。
                </td>
                <td className="width100">https://open.aliyun.com/</td>
              </tr>
              <tr>
                <td className="width100">中国移动</td>
                <td>获取用户当前手机SIM卡及手机设备识别码信息</td>
                <td>用户使用一键登录时使用</td>
                <td className="width100">com.cmic.sso</td>
                <td>
                  设备信息： 手机SIM卡信息（运营商、手机号归属、IMSI）、设备IMEI、MEID、AndroidID、OAID、设备型号、设备制造商、操作系统版本、应用包名、IP地址、网络类型、设备唯一识别码、设备序列号。
                </td>
                <td className="width100">http://dev.10086.cn/</td>
              </tr>
              <tr>
                <td className="width100">高德地图</td>
                <td>获取当前地理位置信息</td>
                <td>用户进行房源维护时使用</td>
                <td className="width100">com.amap.api</td>
                <td>
                  设备信息：地理位置信息（经纬度、定位时间、定位方式、定位准确度）、GPS信息、设备型号、操作系统版本、应用包名、网络类型、IP地址、设备MAC地址、AndroidID、OAID、设备传感器信息（如加速度、方向等）。
                </td>
                <td className="width100">https://lbs.amap.com/</td>
              </tr>
            </table>
            <p className="subTitle">
              如果我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会单独征求您的授权同意。
            </p>
            <p>集成的极光推送 (cn.jiquang) 自启动服务用于提高消息推送通达度。</p>
            <p>
              目的:
              1.能及时收到应用聊天功能其他人发送的消息;2.能提高收到推送的通达度，方便用户接收其他渠道来的消息，更好的管理房源。
            </p>
            <p>方式: 集成极光推送sdk，可参照上方第三方sdk集成列表中极光推送描述.</p>
            <p>范围:仅用于相应的功能.</p>
            <p className="bold subTitle">5. 为向您提供服务，我们可能接入第三方SDK。以下为接入的第三方SDK及其收集的个人信息类型、目的、方式和范围：</p>

            <p className="bold">1. 火山引擎增长营销套件SDK（由北京火山引擎科技有限公司提供）</p>
            <p>SDK名称：火山引擎增长营销套件SDK</p>
            <p>SDK包名：com.bytedance.bdtracker</p>
            <p>SDK开发者：北京火山引擎科技有限公司</p>
            <p>收集的个人信息类型：OAID、AndroidID、设备序列号、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址、Wi-Fi 信息（包括 BSSID 等网络标识）</p>
            <p>收集目的：OAID用于设备唯一标识，提升广告投放效果归因分析的准确性，优化广告投放策略；AndroidID、设备序列号用于设备识别和用户行为分析；设备型号、设备制造商、操作系统版本用于统计分析、性能优化和兼容性分析；应用版本号、应用包名用于应用版本管理和统计分析；网络类型、IP地址、Wi-Fi 信息（包括 BSSID 等网络标识）用于网络环境分析、反作弊和性能优化</p>
            <p>收集方式：SDK在用户同意隐私政策后自动收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于广告投放效果分析和优化、用户行为分析，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与北京火山引擎科技有限公司共享上述信息，用于提供广告投放和数据分析服务</p>
            <p>隐私政策链接：https://www.volcengine.com/docs/84129/1261812</p>

            <p className="bold">2. 转化SDK（由北京巨量引擎网络技术有限公司提供）</p>
            <p>SDK名称：转化SDK</p>
            <p>SDK包名：com.bytedance.ads.convert</p>
            <p>SDK版本：1.3.2.1</p>
            <p>SDK开发者：北京巨量引擎网络技术有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</p>
            <p>收集目的：用于广告投放效果归因分析、反作弊、优化广告投放效果，实现广告转化效果的精准统计和分析</p>
            <p>收集方式：SDK在用户同意隐私政策后自动收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于广告转化效果分析和优化，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与北京巨量引擎网络技术有限公司共享上述信息，用于提供广告投放和数据分析服务</p>
            <p>隐私政策链接：https://open.oceanengine.com/labels/7/docs/1708428054592516?origin=left_nav</p>

            <p className="bold">3. 巨量引擎AppLog SDK（由北京巨量引擎网络技术有限公司提供）</p>
            <p>SDK名称：巨量引擎AppLog SDK</p>
            <p>SDK版本：6.16.9</p>
            <p>SDK开发者：北京巨量引擎网络技术有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</p>
            <p>收集目的：用于统计分析、性能监控、异常追踪，帮助优化应用性能和用户体验</p>
            <p>收集方式：SDK在用户同意隐私政策后自动收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于数据分析和性能优化，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与北京巨量引擎网络技术有限公司共享上述信息，用于提供数据分析和性能监控服务</p>
            <p>隐私政策链接：https://www.oceanengine.com/privacy</p>

            <p className="bold">4. 华为HMS Push SDK（由华为技术有限公司提供）</p>
            <p>SDK名称：华为HMS Push SDK</p>
            <p>SDK版本：5.3.0.304</p>
            <p>SDK开发者：华为技术有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备序列号、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址、WiFi信息</p>
            <p>收集目的：设备MAC地址用于设备唯一标识，提升消息推送的准确性和到达率，确保消息能够准确推送到目标设备；软件安装列表用于分析用户设备环境，优化推送策略，避免与已安装应用冲突，提升推送消息的兼容性和用户体验；AndroidID、OAID、设备序列号用于设备识别和消息推送路由；设备型号、设备制造商、操作系统版本用于推送服务的正常运行和统计分析，确保推送消息与设备兼容；应用版本号、应用包名用于应用版本管理和推送策略优化；网络类型、IP地址、WiFi信息用于网络环境分析和推送策略优化，确保推送消息能够及时送达</p>
            <p>收集方式：SDK在应用启动后自动收集，在用户同意隐私政策后开始收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于华为设备的消息推送服务，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与华为技术有限公司共享上述信息，用于提供消息推送服务</p>
            <p>隐私政策链接：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021</p>

            <p className="bold">5. 极光推送SDK（由深圳市和讯华谷信息技术有限公司提供）</p>
            <p>SDK名称：极光推送SDK（JPush）</p>
            <p>SDK版本：5.2.0</p>
            <p>SDK开发者：深圳市和讯华谷信息技术有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、IMEI（如可用）、设备序列号、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址、WiFi信息、粗略位置信息</p>
            <p>收集目的：设备MAC地址用于设备唯一标识，提升消息推送的准确性和到达率，确保消息能够准确推送到目标设备；软件安装列表用于分析用户设备环境，优化推送策略，避免与已安装应用冲突，提升推送消息的兼容性和用户体验；AndroidID、OAID、IMEI、设备序列号用于设备识别和消息推送路由；设备型号、设备制造商、操作系统版本用于推送服务的正常运行和统计分析，确保推送消息与设备兼容；应用版本号、应用包名用于应用版本管理和推送策略优化；网络类型、IP地址、WiFi信息用于网络环境分析和推送策略优化，确保推送消息能够及时送达；粗略位置信息用于地理位置相关的推送服务</p>
            <p>收集方式：SDK在应用启动后自动收集，在用户同意隐私政策后开始收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于消息推送服务，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与深圳市和讯华谷信息技术有限公司共享上述信息，用于提供消息推送服务</p>
            <p>隐私政策链接：https://www.jiguang.cn/license/privacy</p>

            <p className="bold">6. 极光推送-小米插件（由北京小米移动软件有限公司提供）</p>
            <p>SDK名称：小米推送插件</p>
            <p>SDK版本：5.2.0</p>
            <p>SDK开发者：北京小米移动软件有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</p>
            <p>收集目的：设备MAC地址用于设备唯一标识，提升消息推送的准确性和到达率，确保消息能够准确推送到目标设备；软件安装列表用于分析用户设备环境，优化推送策略，避免与已安装应用冲突，提升推送消息的兼容性和用户体验；AndroidID、OAID用于设备识别和消息推送路由；设备型号、设备制造商、操作系统版本用于小米设备的消息推送服务，确保推送消息与设备兼容；应用版本号、应用包名用于应用版本管理和推送策略优化；网络类型、IP地址用于网络环境分析和推送策略优化，确保推送消息能够及时送达</p>
            <p>收集方式：SDK在应用启动后自动收集，在用户同意隐私政策后开始收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于小米设备的消息推送服务，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与北京小米移动软件有限公司共享上述信息，用于提供消息推送服务</p>
            <p>隐私政策链接：https://dev.mi.com/console/doc/detail?pId=1822</p>

            <p className="bold">7. 极光推送-OPPO插件（由OPPO广东移动通信有限公司提供）</p>
            <p>SDK名称：OPPO推送插件</p>
            <p>SDK版本：5.2.0</p>
            <p>SDK开发者：OPPO广东移动通信有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</p>
            <p>收集目的：设备MAC地址用于设备唯一标识，提升消息推送的准确性和到达率，确保消息能够准确推送到目标设备；软件安装列表用于分析用户设备环境，优化推送策略，避免与已安装应用冲突，提升推送消息的兼容性和用户体验；AndroidID、OAID用于设备识别和消息推送路由；设备型号、设备制造商、操作系统版本用于OPPO设备的消息推送服务，确保推送消息与设备兼容；应用版本号、应用包名用于应用版本管理和推送策略优化；网络类型、IP地址用于网络环境分析和推送策略优化，确保推送消息能够及时送达</p>
            <p>收集方式：SDK在应用启动后自动收集，在用户同意隐私政策后开始收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于OPPO设备的消息推送服务，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与OPPO广东移动通信有限公司共享上述信息，用于提供消息推送服务</p>
            <p>隐私政策链接：https://open.oppomobile.com/wiki/doc#id=10288</p>

            <p className="bold">8. 极光推送-Vivo插件（由维沃移动通信有限公司提供）</p>
            <p>SDK名称：Vivo推送插件</p>
            <p>SDK版本：5.2.0.a</p>
            <p>SDK开发者：维沃移动通信有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</p>
            <p>收集目的：设备MAC地址用于设备唯一标识，提升消息推送的准确性和到达率，确保消息能够准确推送到目标设备；软件安装列表用于分析用户设备环境，优化推送策略，避免与已安装应用冲突，提升推送消息的兼容性和用户体验；AndroidID、OAID用于设备识别和消息推送路由；设备型号、设备制造商、操作系统版本用于Vivo设备的消息推送服务，确保推送消息与设备兼容；应用版本号、应用包名用于应用版本管理和推送策略优化；网络类型、IP地址用于网络环境分析和推送策略优化，确保推送消息能够及时送达</p>
            <p>收集方式：SDK在应用启动后自动收集，在用户同意隐私政策后开始收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于Vivo设备的消息推送服务，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与维沃移动通信有限公司共享上述信息，用于提供消息推送服务</p>
            <p>隐私政策链接：https://dev.vivo.com.cn/documentCenter/doc/366</p>

            <p className="bold">9. 极光推送-Honor插件（由荣耀终端有限公司提供）</p>
            <p>SDK名称：Honor推送插件</p>
            <p>SDK版本：5.2.0</p>
            <p>SDK开发者：荣耀终端有限公司</p>
            <p>收集的个人信息类型：AndroidID、OAID、设备MAC地址、软件安装列表、设备型号、设备制造商、操作系统版本、应用版本号、应用包名、网络类型、IP地址</p>
            <p>收集目的：设备MAC地址用于设备唯一标识，提升消息推送的准确性和到达率，确保消息能够准确推送到目标设备；软件安装列表用于分析用户设备环境，优化推送策略，避免与已安装应用冲突，提升推送消息的兼容性和用户体验；AndroidID、OAID用于设备识别和消息推送路由；设备型号、设备制造商、操作系统版本用于Honor设备的消息推送服务，确保推送消息与设备兼容；应用版本号、应用包名用于应用版本管理和推送策略优化；网络类型、IP地址用于网络环境分析和推送策略优化，确保推送消息能够及时送达</p>
            <p>收集方式：SDK在应用启动后自动收集，在用户同意隐私政策后开始收集，通过系统API获取上述信息</p>
            <p>使用范围：仅用于Honor设备的消息推送服务，不会用于其他用途，不会与第三方共享用于其他目的</p>
            <p>是否共享：是，会与荣耀终端有限公司共享上述信息，用于提供消息推送服务</p>
            <p>隐私政策链接：https://developer.hihonor.com/cn/kitdoc?category=PushKit&kitId=11001&navigation=guides&docId=privacy-statement.md</p>
          </div>

          <div id="num4">
            <p className="bold subTitle">4. 我们如何共享、转让、公开披露您的个人信息</p>
            <p className="subTitle">4.1 共享您的个人信息</p>
            <p>A. 我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
            <p>1.事先获得您的明确授权或同意： 获得您的明确同意后，我们会与其他方共享您的个人信息；</p>
            <p>2. 在法定情形下的共享： 根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；</p>
            <p>
              3.
              在法律要求或允许的范围内，为了保护路客云及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；
            </p>
            <p>
              4.
              与我们的关联公司共享： 您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享受本指引所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；
            </p>
            <p>
              5.
              与授权合作伙伴共享： 为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，路客云向您寄送礼品时，路客云需要与物流服务提供商共享您的个人信息才能安排寄送。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本指引以及其他任何相关的保密和安全措施来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。 如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在路客云中使用该第三方服务。
            </p>
            <p className="subTitle">目前，我们的授权合作伙伴包括以下类型：</p>
            <p>
              •
              广告、分析服务类的授权合作伙伴。 除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱）与提供广告、分析服务的合作伙伴分享。对于广告合作伙伴，我们可能会向其提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行匿名化处理，以便它不会识别到您个人。对于分析数据的伙伴，为了更好的分析路客云用户的使用情况，我们可能向其提供路客云用户的数量、地区分布、活跃情况等数据，但我们仅会向这些合作伙伴提供不能识别个人身份的统计信息（例如「位于北京的
              25 岁男性，喜欢软件开发」）；
            </p>
            <p>
              •
              供应商、服务提供商和其他合作伙伴。 我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴共享（例如代表我们发出电邮或推送通知的通讯服务供应商，以及向为我们和您提供协助的地图服务供应商分享位置数据，向提供人脸识别的服务供应商提供帐号名称和头像图片数据），这些信息的用途受到如下限制：
            </p>
            <p>- 协助我们向您提供服务；</p>
            <p>- 协助我们履行在上文「向您提供产品和/或服务」一节所载的目的；</p>
            <p>
              - 履行我们根据《路客云服务协议》或本指引的责任和实现我们的权利，及／或协助理解和改善路客云提供的服务；
            </p>
            <p>
              - 提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、支付便利或进行学术研究和调查。
            </p>
            <p>
              B.
              就上述目的而言，在本「共享您的个人信息」一节提及的任何第三方所在的位置或使用您的个人信息的位置可能会在您的司法管辖区以外的地区，包括可能没有与您所在司法管辖区的法律实质上相似或达到该等法律目的的个人信息保护法规的地区；
            </p>
            <p>
              C.有关共享信息的提示：通过由我们或第三方提供的功能，您可以主动公开分享、共享信息（如向其他互联网平台转发内容），在这种情况下共享信息将被广泛并即时传送。
            </p>
            <p>
              但只要您不删除被共享的信息，该信息会一直留存在公众领域；在一些情况下，即使您删除共享信息，该等信息仍可由其他用户或与我们没有关联及不受我们控制的第三方独立地缓存、复制或储存，或通过其他用户或该等第三方在公众领域保存。例如，当您将您在路客云发表的评论转发到其他互联网平台，该平台将可能独立的展示、缓存或保存您转发的内容，其他互联网用户也可能转发、保存您的评论，而相应的页面将不受路客云的控制。
            </p>
            <p className="subTitle">4.2. 转让</p>
            <p>
              除非获取您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本指引的约束。如果本指引中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。
            </p>
            <p className="subTitle">4.3. 公开披露</p>
            <p>
              除非获取您的明确同意，我们不会公开披露您的个人信息。基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。
            </p>
            <p className="subTitle">4.4. 共享、转让、公开披露个人信息授权同意的例外</p>
            <p>
              根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下共享、转让、公开披露您的个人信息：
            </p>
            <p>A. 与国家安全、国防安全有关的；</p>
            <p>B. 与公共安全、公共卫生、重大公共利益有关的；</p>
            <p>C. 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
            <p>D. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
            <p>E. 您自行向社会公众公开的个人信息；</p>
            <p>F. 从合法公开披露的信息中收集到的个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
            <p>G. 法律法规规定的其他情形。</p>
            <p>
              根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
            </p>
          </div>

          <div id="num5">
            <p className="bold subTitle">5. 我们如何保护您的个人信息</p>
            <p>
              您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。
            </p>
            <p className="bold subTitle">5.1 技术措施与数据安全措施</p>
            <p>
              我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息安全。我们积极建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。我们通过与信息接触者签署保密协议、监控和审计机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与路客云之间交换数据（如信用卡信息）时受
              SSL 加密保护；我们同时对本指引「引言」中出现的网站提供 https
              安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可以访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
            </p>
            <p className="bold subTitle">5.2 安全事件处置</p>
            <p>
              我们将尽力确保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及在互联网行业可能存在的各种恶意手段，不可能始终保证信息百分之百的安全。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。为防止安全事故的发生，我们制定了妥善的预警机制和应急预案。若不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，并立即启动应急预案，力求将损失最小化。我们将及时将事件相关情况以电话、推送通知等方式告知您，难以逐一告知用户时，我们会采取合理、有效的方式发布公告。
            </p>
            <p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。</p>
          </div>

          <div id="num6">
            <p className="bold subTitle">6. 您管理个人信息的权利</p>
            <p>
              我们非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
            </p>
            <p className="bold subTitle">6.1 访问和更正您的个人信息</p>
            <p>A. 除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：</p>
            <p>1. 电脑端：登录“路客云官网”，点击“我的路客云-个人中心—修改个人资料”；</p>
            <p>2. 手机客户端：登录路客云应用，进入个人中心点击“我的—设置”；</p>
            <p>3. 手机网页版：登录“路客云官网”，点击“页面右上角菜单栏—我的—头像—个人资料”；</p>
            <p>
              B.
              如果您需要查阅您在使用路客云过程中产生的其他个人信息，在合理要求下，我们会向您提供。若您无法通过上述方式访问或者更正您的个人信息的，也可以通过手机客户端或电脑官网联系我们。我们会在
              15 日回复您的访问请求。
            </p>
            <p className="bold subTitle">6.2 删除您的个人信息</p>
            <p>A. 我们在路客云 App 上提供以下方式帮助您删除您在路客云上发布的信息。</p>
            <p>1. 手机客户端：登录路客云应用，进入个人中心点击“我的—设置”；</p>
            <p>B. 在以下情形中，您可以向我们提出删除个人信息的请求：</p>
            <p>1. 如果我们处理个人信息的行为违反法律法规；</p>
            <p>2. 如果我们收集、使用您的个人信息，却未征得您的同意；</p>
            <p>3. 如果我们处理个人信息的行为违反了与您的约定；</p>
            <p>4. 如果您注销了路客云帐号；</p>
            <p>5. 如果我们终止服务及运营。</p>
            <p>
              以上删除请求一旦被响应，我们还将同时通知从路客云获得您个人信息的第三方实体（例如使用路客云帐号作为第三方登录账号的其他互联网平台），要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
            </p>
            <p>如果您在删除过程中遇到任何问题，请联系我们。我们会在 15 日回复您的请求。</p>
            <p className="bold subTitle">6.3 设备权限调用</p>
            <p>
              我们在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机、手机通讯录、蓝牙等访问权限。
            </p>
            <p className="bold subTitle">6.4 注销您的帐号</p>
            <p>如果您需要注销您的路客云帐号，您可以通过联系我们，由客服验证后完成账户的注销申请。</p>
            <p>
              在您主动注销账户之后，我们将停止为您提供产品或服务，不会再收集、使用或共享与该账户相关的个人信息，但之前的信息我们仍需按照监管要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询。如有问题，可以联系路客云客服
            </p>
            <p className="bold subTitle">6.5 响应您的上述请求</p>
            <p>
              为保障安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。您可能需要提供书面请求，或以其他方式证明您的身份。对于您的请求，我们原则上将于
              15 日内做出答复。
            </p>
            <p>
              对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
            </p>
            <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
            <p>1. 与国家安全、国防安全直接相关的；</p>
            <p>2. 与公共安全、公共卫生、重大公共利益直接相关的；</p>
            <p>3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
            <p>4. 有充分证据表明您存在主观恶意或滥用权利的；</p>
            <p>5. 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
            <p>6. 涉及商业秘密的。</p>
          </div>

          <div id="num7">
            <p className="bold subTitle">7. 我们发出的通知</p>
            <p className="subTitle">7.1. 通知及其他类别的通讯</p>
            <p>当您使用路客云服务时，我们可利用您的个人信息向您的设备发出推送通知。</p>
            <p className="subTitle">7.2. 与服务有关的公告</p>
            <p>
              我们可在我们认为必需时（例如当我们暂停路客云服务进行维修时）不时向您发出一些与服务有关的公告。您不可取消这些与服务有关、性质不属于推广的公告。
            </p>
          </div>

          <div id="num8">
            <p className="bold subTitle">8. 您个人信息的存储</p>
            <p>
              我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。如果发生数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。
            </p>
            <p>
              我们承诺您个人信息的存储时间始终处于合理必要期限内。在仅浏览功能下所收集的个人信息如浏览记录、IP
              信息，我们的存储期限不会超过一个月。对于超出期限的个人信息，我们会立即删除或做匿名化处理。
            </p>
            <p>
              如我们因经营不善或其他原因出现停止运营的情况，我们会立即停止对您个人信息的收集，删除已收集的个人信息。我们会将此情况在网站上进行公告或以站内信、邮件等其他合理方式逐一传达到各个用户。
            </p>
          </div>

          <div id="num9">
            <p className="bold subTitle">9. 我们如何使用 Cookie 和其他追踪技术</p>
            <p>
              您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie
              通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在
              Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用 Cookie
              功能后，可能影响您访问路客云或不能充分取得路客云提供的服务。
            </p>
            <p>
              我们不会将 Cookie 用于本指引所述目的之外的任何用途。您可根据自己的偏好管理或删除
              Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。
            </p>
          </div>

          <div id="num10">
            <p className="bold subTitle">10. 我们如何处理未成年人的个人信息</p>
            <p>
              10.1 路客云服务主要面向成人。我们的产品、网站和服务主要面向成人。若您是 18
              周岁以下的未成年人，在使用我们的产品和/或服务前，您应在监护人的陪同下阅读本指引，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。 我们会根据国家相关法律法规的规定着重保护未成年人的个人信息。
            </p>
            <p>
              10.2
              如您的监护人不同意您按照本指引使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们。
            </p>
            <p>
              10.3
              对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
            </p>
            <p>
              10.4
              若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系。我们将根据国家相关法律法规及本指引的规定保护未成年人用户信息的保密性及安全性。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
            </p>
          </div>

          <div id="num11">
            <p className="bold subTitle">11. 如何更新与修改本指引</p>
            <p>11.1 本指引为《路客云服务协议》的重要组成部分。路客云保留不时更新或修改本指引的权利。</p>
            <p>
              11.2 未经您明确同意，我们不会削减您按照本指引所应享有的权利。我们会通过 App
              客户端推送通知、弹窗形式等合理方式通知您，以便您能及时了解本指引所做的任何变更。
            </p>
            <p>
              11.3
              对于重大变更，视具体情况我们 可能还会提供更为显著的通知说明本指引的具体变更内容。 重大变更包括但不限于：
            </p>
            <p>A. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
            <p>B. 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
            <p>C. 个人信息共享、转让或公开披露的主要对象发生变化；</p>
            <p>D. 您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
            <p>E. 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
            <p>F. 个人信息安全影响评估报告表明存在高风险时。</p>
            <p>
              11.4
              若您不同意修改后的隐私保护指引，您有权并应立即停止使用路客云的服务。如果您继续使用路客云的服务，则视为您接受路客云对本指引相关条款所做的修改。
            </p>
          </div>

          <div id="num12">
            <p className="bold subTitle">12. 如何联系我们</p>
            <p>当您对本指引有任何疑问，可以通过联系我们，我们将及时解决您的问题。</p>
            <p>一般情况下，我们将在三十天内回复。</p>
          </div>

          <div id="num13">
            <p className="bold subTitle">13. 争议解决</p>
            <p>13.1. 因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至广州市海珠区人民法院。</p>
            <p>13.2 如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。</p>
          </div>

          <div id="num14">
            <p className="bold subTitle">14. 名词解释</p>
            <p>本隐私保护指引中使用到的名词，在通常意义中有如下定义：</p>
            <p>
              1.
              个人信息：个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。
            </p>
            <p>
              2.
              个人敏感信息：个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。
            </p>
            <p>
              3. 设备： 设备是指可用于访问路客云产品和/或服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。
            </p>
            <p>
              4. 唯一设备标识符： 唯一设备标识符（专属 ID 或
              UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的 IMEI
              号）。唯一设备标识符有多种用途，其中可在不能使用 Cookie（例如在移动应用程序中）时用以提供广告。
            </p>
            <p>
              5. SSL： SSL（Secure Socket Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL
              支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。
            </p>
            <p>
              6. 信息收集技术：我们在《路客云隐私保护指引》中所述的“自动收集”包括以下方式： A. Cookie（曲奇档案） Cookie
              是您浏览网页时，网站服务器放在客户端（您的计算机、移动电话或其他智能终端内）里面的一个小小的文本文件，当您再次访问相应网站时，网站就可通过
              Cookie 识别您的浏览器。Cookie 可能会存储用户偏好及其他信息。您可以将浏览器配置为拒绝所有 Cookie
              或在网站发送 Cookie 时显示提示。不过，如果没有 Cookie，某些网站功能或服务可能无法正常工作。 B. Web
              beacon（网络信标） Web beacon
              是装嵌在网站或电邮内的电子图像文件案或其他技术，可用于计算访客数目、记录您是否及何时阅览电邮或网站，或用以使用某些
              Cookie。 C. Log files（日志文件） Log files 储存自动收集的若干数据。该等数据包括互联网协议（ IP
              ）地址、浏览器类型、互联网服务提供商（ ISP ）、引用/退出页面、操作系统、日期/时间戳和点击流数据等。 D. ET
              Tag（实体标签） ET Tag 是在互联网浏览器与互联网服务器之间背后传送的 HTTP 协议标头，可代替
              Cookie，用以追踪个别使用者，使我们可更深入地了解和改善我们的服务。 E. JavaScript JavaScript
              是一种编程语言，用于制作更具互动性和动态的网页。JavaScript 可以设定 Cookie、阅读 Cookie 及删除 Cookie。
            </p>
            <p>
              7.关联公司： 指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被依法认定的方式。
            </p>
            <p>
              8.应用数据缓存： 应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。
            </p>
            <p>
              9. 帐户： 只要注册帐号并向我们提供一些个人信息（本指引 3.1
              节已经说明），您就可以使用我们的服务。当您访问路客云时，系统会利用这些帐号信息对您进行身份验证，以防止未经授权的人员访问您的帐号。
            </p>
            <p>10. 匿名化： 指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</p>
          </div>
          <div>
            <p className="subTitle">
              如果您想行使其中任何一项权利，或对此份隐私政策有任何问题或疑虑，可通过以下方式联系我们:
            </p>
            <p>联系人：李先生</p>
            <p>致电：18520061109</p>
            <p>发电邮至：msbapp@localhome.com.cn</p>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
